export default __webpack_public_path__ + "static/media/Trash.577cec18.svg";